import { selectLayerIndex } from '@/map/layers/registry';
import type { Tool } from './types';

type Input = {
  name_contains?: string;
  geometry_type?: 'point' | 'multipoint' | 'polyline' | 'polygon';
  include_secondary?: boolean;
};

export const listLayers: Tool<Input> = {
  name: 'list_layers',
  description:
    'Filter the registered layer index by name fragment, geometry type, or flags. Pure read; never probes.',
  input_schema: {
    type: 'object',
    properties: {
      name_contains: { type: 'string' },
      geometry_type: {
        enum: ['point', 'multipoint', 'polyline', 'polygon'],
      },
      include_secondary: {
        type: 'boolean',
        description: 'Include layers flagged "secondary" (hidden from default panel).',
      },
    },
    additionalProperties: false,
  },
  execute: (input) => {
    const records = selectLayerIndex();
    const needle = input?.name_contains?.toLowerCase();
    return records
      .filter((r) => input?.include_secondary || !r.flags.has('secondary'))
      .filter((r) => !needle || r.id.toLowerCase().includes(needle))
      .filter(
        (r) =>
          !input?.geometry_type ||
          r.probe?.service.geometry_type === input.geometry_type,
      )
      .map((r) => ({
        id: r.id,
        geometry_type: r.probe?.service.geometry_type,
        status: r.status,
        flags: Array.from(r.flags),
      }));
  },
};
